import React from 'react'

const Courses = () => {
  return (
    <>
    {/* ======== 2.1. Subpage_Hero section ======== */}
    <section className="Subpage_Hero">
      <div className="container">
        <div className="text-lg-start text-center" data-aos="fade-up">
          <h1>Our Classes</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
            aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
            sodales quis. Pulvinar consectetur amet cursus netus at.
          </p>
        </div>
      </div>
    </section>
    {/* ======== End of 2.1. Subpage_Hero section ======== */}
    {/* ======== 1.5. Courses section ========  */}
    <section className="Courses Classes_Courses">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6" data-aos="flip-left">
            <div className="d-flex flex-column position-relative">
              <figure>
                <img
                  className="w-100"
                  src="assets/images/Courses/courses_1.webp"
                  alt="courses_1"
                />
              </figure>
              <div className="d-flex flex-column text-center">
                <h4>Drawing Class</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut.
                </p>
                <div>
                  <a href="#" className="hover3">
                    Join Now <i className="fa fa-arrow-right-long" />
                  </a>
                </div>
              </div>
              <div className="position-absolute" />
            </div>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="flip-left">
            <div className="d-flex flex-column position-relative">
              <figure>
                <img
                  className="w-100"
                  src="assets/images/Courses/courses_2.webp"
                  alt="courses_2"
                />
              </figure>
              <div className="d-flex flex-column text-center">
                <h4>Number Matching</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut.
                </p>
                <div>
                  <a href="#" className="hover3">
                    Join Now <i className="fa fa-arrow-right-long" />
                  </a>
                </div>
              </div>
              <div className="position-absolute" />
            </div>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="flip-left">
            <div className="d-flex flex-column position-relative">
              <figure>
                <img
                  className="w-100"
                  src="assets/images/Courses/courses_3.webp"
                  alt="courses_3"
                />
              </figure>
              <div className="d-flex flex-column text-center">
                <h4>Paper Art</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut.
                </p>
                <div>
                  <a href="#" className="hover3">
                    Join Now <i className="fa fa-arrow-right-long" />
                  </a>
                </div>
              </div>
              <div className="position-absolute" />
            </div>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="flip-left">
            <div className="d-flex flex-column position-relative">
              <figure>
                <img
                  className="w-100"
                  src="assets/images/Courses/courses_4.webp"
                  alt="courses_4"
                />
              </figure>
              <div className="d-flex flex-column text-center">
                <h4>Swimming Class</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut.
                </p>
                <div>
                  <a href="#" className="hover3">
                    Join Now <i className="fa fa-arrow-right-long" />
                  </a>
                </div>
              </div>
              <div className="position-absolute" />
            </div>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="flip-left">
            <div className="d-flex flex-column position-relative">
              <figure>
                <img
                  className="w-100"
                  src="assets/images/Courses/courses_5.webp"
                  alt="courses_5"
                />
              </figure>
              <div className="d-flex flex-column text-center">
                <h4>Sports Class</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut.
                </p>
                <div>
                  <a href="#" className="hover3">
                    Join Now <i className="fa fa-arrow-right-long" />
                  </a>
                </div>
              </div>
              <div className="position-absolute" />
            </div>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="flip-left">
            <div className="d-flex flex-column position-relative">
              <figure>
                <img
                  className="w-100"
                  src="assets/images/Courses/courses_6.webp"
                  alt="courses_6"
                />
              </figure>
              <div className="d-flex flex-column text-center">
                <h4>Kids Care</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut.
                </p>
                <div>
                  <a href="#" className="hover3">
                    Join Now <i className="fa fa-arrow-right-long" />
                  </a>
                </div>
              </div>
              <div className="position-absolute" />
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* ======== End of 1.5. Courses section ========  */}
  </>
   
  )
}

export default Courses
